import React from 'react';
import { PropTypes } from 'prop-types';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { styled } from '@mui/material/styles';

const StyledAlert = styled(({ overrideStyles, theme, ...props }) => <Alert {...props} />)(({ overrideStyles }) => ({
  marginBottom: '1rem',
  marginTop: '1rem',
  minWidth: '0',
  '& .MuiAlert-message': {
    minWidth: '0',
    overflowWrap: 'break-word',
  },
  ...overrideStyles,
}));

const InfoNotification = ({ title, children, overrideStyles = {} }) => {
  return (
    <StyledAlert severity="info" overrideStyles={overrideStyles}>
      <AlertTitle>{title}</AlertTitle>
      {children}
    </StyledAlert>
  );
};

InfoNotification.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  overrideStyles: PropTypes.object,
};

export { InfoNotification };
